import { IAction, IAppState } from 'models/store.model'
import {
  AnyAction,
  applyMiddleware,
  legacy_createStore as createStore,
  Store,
} from 'redux'
import { composeWithDevTools } from '@redux-devtools/extension'
import thunk, { ThunkDispatch } from 'redux-thunk'
import { rootReducer } from './rootReducer'

export type TAppStore = Store<IAppState>
export type TAppDispatch = ThunkDispatch<IAppState, any, AnyAction>

export const enhancer = composeWithDevTools(applyMiddleware(thunk))
export const store: TAppStore = createStore<IAppState, IAction<any>, any, any>(
  rootReducer,
  enhancer,
)
